module.exports = __webpack_public_path__ + "static/media/region_other.30bb93a8.jpg";